import type { BookedFlightItineraryWithDepartureTime } from "@b2bportal/air-booking-api";
import type { AirportMap } from "@b2bportal/core-flights";
import { ProductType } from "@b2bportal/core-types";
import {
  TripHeader as SharedTripHeader,
  TripsReservationStatusPill,
  useFlightTripHeader,
} from "@/components";

interface FlightTripHeaderProps {
  className?: string;
  itinerary: BookedFlightItineraryWithDepartureTime;
  isCfarExercised: boolean;
  airportMap?: AirportMap;
}

export const FlightTripHeader = ({
  itinerary,
  airportMap,
  isCfarExercised,
  className,
}: FlightTripHeaderProps) => {
  const { flightStatus, ...tripHeaderProps } = useFlightTripHeader({
    itinerary,
    airportMap,
    isCfarExercised,
    className,
  });

  const statusPill = (
    <TripsReservationStatusPill
      variant={ProductType.FLIGHTS}
      status={flightStatus}
    />
  );

  return <SharedTripHeader {...tripHeaderProps} statusPill={statusPill} />;
};
